/**
 * Mock Clock Entry Data
 * Sample clock in/out entries for multiple drivers over 7 days
 */

import type { ClockEntry } from '../types'

// Get dates for the past 7 days
const today = new Date()
const getDateDaysAgo = (days: number): Date => {
  const date = new Date(today)
  date.setDate(date.getDate() - days)
  return date
}

// Mock clock entries for multiple drivers
export const mockClockEntries: ClockEntry[] = [
  // Driver 1 - Today
  {
    id: 'mock-clock-001',
    driverId: 'driver-001',
    type: 'clock-in',
    timestamp: new Date(today.setHours(8, 0, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzUyQzQxQSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIEluPC90ZXh0Pjwvc3ZnPg==',
    location: {
      latitude: 40.7128,
      longitude: -74.0060,
      accuracy: 10,
      timestamp: new Date(today.setHours(8, 0, 0)).toISOString()
    },
    status: 'synced'
  },
  
  // Driver 2 - Today
  {
    id: 'mock-clock-002',
    driverId: 'driver-002',
    type: 'clock-in',
    timestamp: new Date(today.setHours(7, 45, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzUyQzQxQSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIEluPC90ZXh0Pjwvc3ZnPg==',
    location: {
      latitude: 40.7589,
      longitude: -73.9851,
      accuracy: 8,
      timestamp: new Date(today.setHours(7, 45, 0)).toISOString()
    },
    status: 'synced'
  },

  // Driver 1 - Yesterday (full day)
  {
    id: 'mock-clock-003',
    driverId: 'driver-001',
    type: 'clock-in',
    timestamp: new Date(getDateDaysAgo(1).setHours(8, 15, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzUyQzQxQSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIEluPC90ZXh0Pjwvc3ZnPg==',
    location: {
      latitude: 40.7128,
      longitude: -74.0060,
      accuracy: 10,
      timestamp: new Date(getDateDaysAgo(1).setHours(8, 15, 0)).toISOString()
    },
    status: 'synced'
  },
  {
    id: 'mock-clock-004',
    driverId: 'driver-001',
    type: 'clock-out',
    timestamp: new Date(getDateDaysAgo(1).setHours(17, 30, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0ZGNTE1NyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIE91dDwvdGV4dD48L3N2Zz4=',
    location: {
      latitude: 40.7128,
      longitude: -74.0060,
      accuracy: 10,
      timestamp: new Date(getDateDaysAgo(1).setHours(17, 30, 0)).toISOString()
    },
    status: 'synced'
  },

  // Driver 2 - Yesterday (full day)
  {
    id: 'mock-clock-005',
    driverId: 'driver-002',
    type: 'clock-in',
    timestamp: new Date(getDateDaysAgo(1).setHours(7, 50, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzUyQzQxQSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIEluPC90ZXh0Pjwvc3ZnPg==',
    location: {
      latitude: 40.7589,
      longitude: -73.9851,
      accuracy: 8,
      timestamp: new Date(getDateDaysAgo(1).setHours(7, 50, 0)).toISOString()
    },
    status: 'synced'
  },
  {
    id: 'mock-clock-006',
    driverId: 'driver-002',
    type: 'clock-out',
    timestamp: new Date(getDateDaysAgo(1).setHours(16, 45, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0ZGNTE1NyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIE91dDwvdGV4dD48L3N2Zz4=',
    location: {
      latitude: 40.7589,
      longitude: -73.9851,
      accuracy: 8,
      timestamp: new Date(getDateDaysAgo(1).setHours(16, 45, 0)).toISOString()
    },
    status: 'synced'
  },

  // Driver 3 - 2 days ago (full day)
  {
    id: 'mock-clock-007',
    driverId: 'driver-003',
    type: 'clock-in',
    timestamp: new Date(getDateDaysAgo(2).setHours(8, 30, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzUyQzQxQSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIEluPC90ZXh0Pjwvc3ZnPg==',
    location: {
      latitude: 40.7306,
      longitude: -73.9352,
      accuracy: 12,
      timestamp: new Date(getDateDaysAgo(2).setHours(8, 30, 0)).toISOString()
    },
    status: 'synced'
  },
  {
    id: 'mock-clock-008',
    driverId: 'driver-003',
    type: 'clock-out',
    timestamp: new Date(getDateDaysAgo(2).setHours(17, 15, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0ZGNTE1NyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNsb2NrIE91dDwvdGV4dD48L3N2Zz4=',
    location: {
      latitude: 40.7306,
      longitude: -73.9352,
      accuracy: 12,
      timestamp: new Date(getDateDaysAgo(2).setHours(17, 15, 0)).toISOString()
    },
    status: 'synced'
  }
]
